<div class="flight">
  <section class="main-cont-ticket">
    <div class="container">
      <div class="row">
        <div
          [ngClass]="{
            open: toggleflt,
            'col-lg-3': true,
            'filters-sect': true
          }"
          *ngIf="!isSummaryPage"
        >
          <ng-container *ngIf="facade.vm$ | async as vm">
            <tic-filters-panel
              [filtersPageType]="filtersPagesTypes.Flights_Page"
              [filtersPageMetaData]="vm.filtersMetadata"
              (onFilterSelected)="filterSelection($event)"
              (clear)="clearFilterPanel()"
              (resetSingle)="clearSingle($event)"
              (close)="togglefltfunc()"
            ></tic-filters-panel>
          </ng-container>
        </div>
        <div 
        [ngClass]="{'col-lg-5': !isSummaryPage, 'col-md-12': !isSummaryPage, 'explore-events': !isSummaryPage}"
        >
          <div class="row explore-head" *ngIf="!isSummaryPage">
            <div class="col-lg-6 col-md-6 title-col">
              <h1>{{"flightsPage.common.title" | i18n}}</h1>
            </div>
            <div class="col-lg-6 col-md-6 srt-col">
              <form>
                <div class="sort-opt">
                  <div class="open-filter" (click)="togglefltfunc()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29"
                      height="28"
                      viewBox="0 0 29 28"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.6585 3.3687H27.4108C28.2764 3.3687 28.9782 4.08699 28.9782 4.973C28.9782 5.85901 28.2764 6.57727 27.4108 6.57727H12.6585C12.0114 8.44451 10.2692 9.78582 8.22586 9.78582C6.18254 9.78582 4.44029 8.44451 3.79326 6.57727H1.58009C0.714451 6.57727 0.0126953 5.85901 0.0126953 4.973C0.0126953 4.08699 0.714451 3.3687 1.58009 3.3687H3.79326C4.44034 1.50146 6.18254 0.160156 8.22586 0.160156C10.2692 0.160156 12.0114 1.50146 12.6585 3.3687ZM6.66006 4.97368C6.66006 5.85828 7.36318 6.57798 8.22745 6.57798C9.09171 6.57798 9.79484 5.85828 9.79484 4.97368C9.79484 4.08908 9.09171 3.36941 8.22745 3.36941C7.36318 3.36941 6.66006 4.08908 6.66006 4.97368ZM12.6585 21.3368H27.4108C28.2764 21.3368 28.9782 22.0551 28.9782 22.9411C28.9782 23.8272 28.2764 24.5454 27.4108 24.5454H12.6585C12.0114 26.4127 10.2692 27.754 8.22586 27.754C6.18254 27.754 4.44029 26.4127 3.79326 24.5454H1.58009C0.714451 24.5454 0.0126953 23.8272 0.0126953 22.9411C0.0126953 22.0551 0.714451 21.3368 1.58009 21.3368H3.79326C4.44034 19.4697 6.18254 18.1284 8.22586 18.1284C10.2692 18.1284 12.0114 19.4697 12.6585 21.3368ZM6.66006 22.9414C6.66006 23.826 7.36318 24.5457 8.22745 24.5457C9.09171 24.5457 9.79484 23.826 9.79484 22.9414C9.79484 22.0568 9.09171 21.3372 8.22745 21.3372C7.36318 21.3372 6.66006 22.0568 6.66006 22.9414ZM27.4108 12.3529H25.1977C24.5506 10.4856 22.8084 9.14434 20.7651 9.14434C18.7217 9.14434 16.9795 10.4856 16.3324 12.3529H1.58009C0.714451 12.3529 0.0126953 13.0712 0.0126953 13.9572C0.0126953 14.8432 0.714451 15.5615 1.58009 15.5615H16.3324C16.9795 17.4287 18.7217 18.77 20.7651 18.77C22.8084 18.77 24.5506 17.4287 25.1977 15.5615H27.4108C28.2764 15.5615 28.9782 14.8432 28.9782 13.9572C28.9782 13.0712 28.2764 12.3529 27.4108 12.3529ZM20.7665 15.5617C19.9023 15.5617 19.1991 14.842 19.1991 13.9574C19.1991 13.0728 19.9023 12.3532 20.7665 12.3532C21.6308 12.3532 22.3339 13.0728 22.3339 13.9574C22.3339 14.842 21.6308 15.5617 20.7665 15.5617Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <label for="inputState" class="">{{"flightsPage.common.sortBy" | i18n}}</label>
                  <tic-sort-filters [isFlightsPage]="true" [sortOptions]="sortOptions" (optionSelected)="sortFlight($event)"></tic-sort-filters>
                  <!-- <div [ngClass]="{ show: showsort, 'sort-mobile': true }">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="19"
                      viewBox="0 0 18 19"
                      fill="none"
                      (click)="togglesort()"
                    >
                      <g clip-path="url(#clip0_854_13562)">
                        <path
                          d="M14.7784 3.71963L11.7784 0.719603L11.778 0.719252C11.7606 0.701934 11.7424 0.685473 11.7234 0.669928C11.7147 0.662791 11.7056 0.656603 11.6967 0.649924C11.686 0.641943 11.6756 0.633682 11.6645 0.626264C11.6538 0.619127 11.6427 0.612939 11.6317 0.6064C11.6217 0.600389 11.6119 0.594096 11.6015 0.588541C11.5903 0.582564 11.5789 0.577502 11.5675 0.572123C11.5567 0.567025 11.5461 0.561646 11.535 0.557041C11.5239 0.552471 11.5126 0.548744 11.5014 0.544736C11.4895 0.540482 11.4778 0.535947 11.4658 0.532291C11.4545 0.528881 11.443 0.526385 11.4317 0.523537C11.4193 0.520408 11.4071 0.516963 11.3946 0.514467C11.3814 0.511865 11.3681 0.510283 11.3549 0.508385C11.3439 0.506838 11.3332 0.504728 11.3221 0.503639C11.2728 0.498787 11.2233 0.498787 11.174 0.503639C11.163 0.504728 11.1522 0.506803 11.1412 0.508385C11.128 0.510283 11.1146 0.51183 11.1015 0.514467C11.0889 0.516963 11.0768 0.520408 11.0644 0.523537C11.053 0.526385 11.0416 0.528881 11.0303 0.532291C11.0183 0.535947 11.0065 0.540482 10.9947 0.544736C10.9835 0.548779 10.9722 0.552471 10.9611 0.557041C10.95 0.561611 10.9394 0.567025 10.9286 0.572123C10.9172 0.577502 10.9058 0.582564 10.8946 0.588541C10.8842 0.594096 10.8744 0.600389 10.8644 0.6064C10.8534 0.612939 10.8423 0.619127 10.8316 0.626264C10.8205 0.633682 10.8101 0.641943 10.7994 0.649924C10.7905 0.656603 10.7814 0.662791 10.7727 0.669928C10.7537 0.685502 10.7355 0.70192 10.7181 0.719252L10.7177 0.719603L7.71775 3.71959C7.42486 4.01248 7.42486 4.48737 7.71775 4.78026C8.01063 5.07314 8.48552 5.07314 8.77841 4.78026L10.4981 3.06059V11.7499C10.4981 12.1642 10.8339 12.4999 11.2481 12.4999C11.6623 12.4999 11.9981 12.1642 11.9981 11.7499V3.06062L13.7177 4.78029C14.0106 5.07318 14.4855 5.07318 14.7784 4.78029C15.0712 4.48737 15.0712 4.01251 14.7784 3.71963ZM9.21769 14.2196L7.49802 15.9393V7.24995C7.49802 6.83574 7.16224 6.49996 6.74803 6.49996C6.33382 6.49996 5.99804 6.83574 5.99804 7.24995V15.9393L4.27838 14.2196C3.98549 13.9267 3.5106 13.9267 3.21771 14.2196C2.92483 14.5125 2.92483 14.9874 3.21771 15.2803L6.2177 18.2803L6.21812 18.2806C6.23545 18.2979 6.2537 18.3144 6.27265 18.3299C6.28133 18.3371 6.29051 18.3433 6.29944 18.35C6.31009 18.358 6.32053 18.3662 6.33161 18.3736C6.34229 18.3808 6.35337 18.387 6.36434 18.3935C6.37439 18.3995 6.3842 18.4058 6.39454 18.4113C6.40572 18.4173 6.41721 18.4224 6.42864 18.4277C6.4394 18.4328 6.45001 18.4382 6.46105 18.4428C6.47213 18.4474 6.48345 18.4511 6.4947 18.4551C6.50654 18.4593 6.51822 18.4639 6.53031 18.4675C6.54156 18.4709 6.55299 18.4734 6.56438 18.4763C6.57672 18.4794 6.58892 18.4829 6.6015 18.4854C6.61468 18.488 6.62797 18.4895 6.64123 18.4914C6.65216 18.493 6.66295 18.4951 6.67403 18.4962C6.72325 18.501 6.77285 18.501 6.82207 18.4962C6.83315 18.4951 6.8439 18.493 6.85487 18.4914C6.86813 18.4895 6.88145 18.488 6.8946 18.4853C6.90718 18.4828 6.91935 18.4794 6.93169 18.4763C6.94308 18.4734 6.9545 18.4709 6.96575 18.4675C6.97785 18.4638 6.98956 18.4593 7.00137 18.4551C7.01262 18.451 7.02394 18.4473 7.03501 18.4427C7.04605 18.4382 7.05663 18.4328 7.06739 18.4277C7.07882 18.4223 7.09035 18.4173 7.10153 18.4112C7.11183 18.4057 7.12164 18.3994 7.13166 18.3935C7.14263 18.3869 7.15374 18.3807 7.16442 18.3736C7.1755 18.3661 7.1859 18.3579 7.19652 18.35C7.20549 18.3433 7.21466 18.337 7.22338 18.3299C7.24219 18.3145 7.26029 18.2982 7.27752 18.281L7.27833 18.2802L10.2783 15.2802C10.5712 14.9873 10.5712 14.5125 10.2783 14.2196C9.98543 13.9267 9.51061 13.9267 9.21769 14.2196Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_854_13562">
                          <rect
                            width="18"
                            height="18"
                            fill="white"
                            transform="translate(0 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="sort-body">
                      <p>Price (High to Low)</p>
                      <p>Price (Low to High)</p>
                    </div>
                  </div> -->
                </div>
              </form>
            </div>
          </div>
          <div
            class="row justify-content-between align-items-center explore-filter"  *ngIf="!isSummaryPage"
          >
            <div class="col-lg-12" *ngIf="facade.vm$ | async as vm">
              <p>{{"flightsPage.common.showing" | i18n}} {{ totalShown }} {{"flightsPage.common.outOf" | i18n}} {{ vm.totalRecords }} {{"flightsPage.common.flightOptions" | i18n}}</p>
            </div>
          </div>
          <div class="cheapest"  *ngIf="!isSummaryPage">
            <tic-quick-filter (quickFilter)="quickFilter($event)" isFlightsPage="true"></tic-quick-filter>
          </div>
          <div class="selected_flight" *ngIf="searchType != undefined">
            <div class="selected_flight_inner" *ngIf="facadeCheckout.flight$ | async as flight">
              <div *ngIf="(flight | json) != '{}'">
                <p>Previous Selected flight: </p>
                <tic-flight-result
                  [flightOffer]="flight"
                  [parseDuration]="parseDuration"
                  [parseLocation]="parseLocation"
                  [isSummary]="false"
                  (onSelectedFlight)="onSelectedFlight($event, flight)"
                >
                </tic-flight-result>
              </div>
            </div>
          </div>
          <div class="row explore-main" *ngIf="facade.vm$ | async as vm">
            <div class="col-lg-12" *ngIf="vm.loaded; else content">
              <div>
                <div
                  infinite-scroll
                  [infiniteScrollDistance]="2"
                  [infiniteScrollThrottle]="1000"
                  (scrolled)="onScroll(vm)"
                >
                  <div
                    *ngFor="
                      let flightOffer of loadedFlights;
                      let i = index;
                      trackBy: trackById
                    "
                  >
                    <div *ngIf="( searchType !== 'local' || !isSelectedFlight(flightOffer) )">
                      <div *ngIf="!isSummaryPage; else SummaryPage" >
                        <tic-flight-result
                          [flightOffer]="flightOffer"
                          [parseDuration]="parseDuration"
                          [parseLocation]="parseLocation"
                          [isSummary]="false"
                          (onSelectedFlight)="onSelectedFlight($event, flightOffer)"
                        >
                        </tic-flight-result>
                      </div>
                        <ng-template #SummaryPage>
                          <tic-flight-result
                          [flightOffer]="flightOffer"
                          [parseDuration]="parseDuration"
                          [parseLocation]="parseLocation"
                          [isSummary]="false"
                          (onSelectedFlight)="summaryEventSelection($event,flightOffer)"
                        >
                        </tic-flight-result>
                        </ng-template>
                    </div>
                  </div>
                  <ng-container *ngIf="!vm.loadMoreActions.loaded && vm.loadMoreActions.loading">
                    <tic-flight-card-skeleton [rpp]="rpp" [totalLeftToFetch]="totalLeftToFetch"></tic-flight-card-skeleton>
                  </ng-container>
                  <ng-template #loadMorePlaceHolders>
                    <ng-container *ngIf="vm.loadMoreActions.error">
                      Error Placeholder for loadMore load
                    </ng-container>
                  </ng-template>
                  <ng-template #content>
                    <ng-container *ngIf="vm.error; else loading">
                      Error Placeholder for initial load
                    </ng-container>
                  </ng-template>
                  <!-- <ng-container *ngIf="isFilterFailed;">
                    <div class="container-element">
                      <div class="text-center"><strong>Whoops</strong></div>
                      <div class="contianer center">
                        <img src="../../../../../../assets/svg-pages/plugs.svg" />
                      </div>
                      <div *ngIf="!showRetryBtn">
                        <div class="text-center">
                          <span>Something went wrong, please click here.</span>
                        </div>
                        <div class="text-center">
                          <button class="btn  btn-sm btn-primary mt-2" (click)="retryFilters()">Retry</button>
                        </div>
                      </div>
                      <div *ngIf="showRetryBtn">
                        <div class="text-center">
                          <span>Something went wrong, please press to refresh the page.</span>
                        </div>
                        <div class="text-center">
                          <button class="btn  btn-sm btn-primary mt-2" (click)="refreshPage()">Refresh</button>
                        </div>
                      </div>
                    </div>
                  </ng-container> -->
                  <ng-container *ngIf="vm.active.length === 0 || isFilterFailed">
                    <img src="../../../../../../assets/svg-pages/no-record-found.svg" />
                    <!-- <div class="error-btn p-2" *ngIf="!showRetryBtn">
                      <div class="text-center">
                        <button class="btn  btn-sm btn-primary mt-2" (click)="retryFilters()">Retry</button>
                      </div>
                    </div>
                    <div class="error-btn p-2" *ngIf="showRetryBtn">
                      <div class="text-center">
                        <button class="btn  btn-sm btn-primary mt-2" (click)="refreshPage()">Refresh</button>
                      </div>
                    </div> -->
                  </ng-container>
                </div>
              </div>
            </div>
            <ng-template #content>
              <ng-container *ngIf="vm.error; else loading">
                Error Placeholder for initial load
              </ng-container>
            </ng-template>
            <ng-template #loading>
              <tic-flight-card-skeleton [rpp]="rpp" [totalLeftToFetch]="totalLeftToFetch"></tic-flight-card-skeleton>
            </ng-template>
          </div>
        </div>
        <div class="col-lg-4 last-sect desktop"  *ngIf="!isSummaryPage">
          <tic-summary-card [showContinue]="false"></tic-summary-card>
        </div>
        <div class="col-lg-4 last-sect tab-mobile" (click)="openpspopup()">
          <div class="checkoutcard">
            <div class="priceinclude">
              <div class="price-head"> 
                <h4>{{"summaryCard.priceIncludes" | i18n}}</h4>
                <h3>{{ totalAmountPp | currencyConverter123 | async }} /pp</h3>
              </div>
              <h5>{{ packageType[packageIndex - 1] | i18n}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<section
  [ngClass]="{ 'open': pspopup ,'price-summary': true }"
  appOutside
  (click)="ClickedOutps($event)"
>
  <div class="ps-container">
    <div class="close-popup">
      <svg
        (click)="closePopupps()"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g opacity="0.5">
          <path
            d="M18 6L6 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 6L18 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
    <tic-price-summary></tic-price-summary>
  </div>
</section>
